import styled from 'styled-components';
import { Deactivation2 } from '@elfsight/widget-deactivation';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import { WidgetBackground } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { meta } from '../meta';
import { Header } from './components/header';
import { Form } from './form/form';
import { renderThumbnailModeMapping } from './render-thumbnail-mode-mapping';
import { Results } from './results/results';
import { useLayoutConfig } from './use-layout-config';

export function Widget() {
  const settings = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);
  const background = renderThumbnailModeMapping(settings);

  const [ref, layoutConfig] = useLayoutConfig(background.isTransparent, [
    settings.horizontalPadding,
    settings.verticalPadding
  ]);
  const isMobile = layoutConfig.layout === 'column';
  const stickResultsToBottom = !background.isTransparent && isMobile;
  const resultsPenetration = stickResultsToBottom
    ? [settings.horizontalPadding, settings.verticalPadding]
    : [0, 0];

  return (
    <>
      <Deactivation2 appAlias={meta.alias} {...settings}>
        <WidgetBackground
          {...background.background}
          horizontalPadding={background.horizontalPadding}
          verticalPadding={background.verticalPadding}
          borderRadius={settings.borderRadius}
          style={{
            overflow: stickResultsToBottom ? 'hidden' : 'unset',
            ...background.style
          }}
        >
          <Container ref={ref}>
            <Header isMobile={isMobile} />
            <Layout
              _direction={layoutConfig.layout}
              _spacing={layoutConfig.sectionsSpacing}
            >
              <Form isMobile={isMobile} />
              <Results
                paddings={layoutConfig.resultsPaddings}
                sticky={layoutConfig.layout === 'row'}
                isMobile={isMobile}
                penetration={resultsPenetration}
                omitBorderRadius={stickResultsToBottom}
              />
            </Layout>
          </Container>
          <FreeLink
            {...freeLinkSettings}
            appAlias={meta.alias}
            appName={meta.name}
            style={{
              link: {
                marginTop: '20px'
              }
            }}
          />
        </WidgetBackground>
      </Deactivation2>
    </>
  );
}

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;

  & div:empty {
    display: block !important;
  }
`;

const Layout = styled.div<{ _direction: 'column' | 'row'; _spacing: number }>`
  position: relative;
  display: grid;
  grid-template-columns: ${({ _direction }) =>
    _direction === 'row' ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)'};
  gap: ${({ _spacing }) => _spacing}px;
  transition: gap 0.2s;
`;
